<template>
  <div class="px-0 py-2 w-full text-left">
    <div class="w-full">
      <div class="flex justify-content-between w-full align-items-center flex-wrap mb-2">
        <div>
          <!-- <h3 class="mb-0 pb-0">Puntos de Encuentro</h3> -->
          <div class="pb-0 font-bold">Puntos de Encuentro:</div>
          <p class="text-xs mb-2">
            Solo para puntos de encuentro generales.
            Para puntos de encuentro de territorios, ir a la sección de territorios.
          </p>
          <p class="text-xs mb-2">
            La estrella marca el punto predeterminado: el mapa se abrirá ahí cuando no haya una posición guardada.
          </p>
        </div>
        <div class="noprint flex">
          <PuntosDeEncuentro class="mx-2" :editItem="editingItem" @saved="editingItem = null" />
        </div>
      </div>
    </div>
    <div class="card">
      <DataTable
        :value="territorios.puntoEncuentro"
        :paginator="false"
        class="p-datatable-customers"
        showGridlines
        :rows="30"
        dataKey="id"
        :filters.sync="filters1"
        filterDisplay="menu"
        responsiveLayout="scroll"
        :globalFilterFields="['lugar']"
      >
        <template #header>
          <div class="flex justify-content-between noprint">
            <Button
              type="button"
              icon="pi pi-filter-slash"
              label="Limpiar"
              class="p-button-outlined noprint"
              @click="clearFilter1()"
            />
            <IconField iconPosition="left">
              <InputIcon class="pi pi-search"> </InputIcon>
              <InputText
                v-model="filters1['global'].value"
                placeholder="Filtrar"
              />
            </IconField>
          </div>
        </template>
        <template #empty> Ningun registro encontrado </template>
        <Column
          :styles="{ 'width': '2.5rem' }"
          bodyStyle="text-align:center;"
        >
          <template #body="{ data }">
            <Button
              :icon="data.isDefault ? 'pi pi-star-fill' : 'pi pi-star'"
              text
              rounded
              class="noprint"
              :severity="data.isDefault ? 'warning' : 'secondary'"
              v-tooltip.top="data.isDefault ? 'Punto predeterminado' : 'Marcar como predeterminado'"
              @click="setDefault(data)"
            />
          </template>
        </Column>
        <Column
          field="lugar"
          header="Punto de Encuentro"
          :styles="{ 'min-width': '12rem' }"
        >
          <template #body="{ data }">
            <div>{{ data.name }}</div>
            <div v-if="data.direccion" class="text-xs text-500">{{ data.direccion }}</div>
          </template>
        </Column>
        <Column
          :styles="{ 'width': '2rem' }"
          bodyStyle="text-align:right;"
        >
          <template #body="{ data }">
            <Button icon="pi pi-pencil" outlined class="noprint" @click="editingItem = { ...data }" />
          </template>
        </Column>
        <Column
          :styles="{ 'width': '2rem' }"
          bodyStyle="text-align:right;"
        >
          <template #body="{ data }">
            <Button icon="pi pi-trash" outlined class="noprint" @click="deleteItem(data)" />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script setup>
import Column from "primevue/column";
import { ref } from "vue";
import { useRouterStore } from "@/store/router";
import { useTerritoriosStore } from "@/store/territorios";
import { useTerritorioStore } from "@/store/territorio";
import { useMapData } from "@/composables/useMapData";

// import ImportTerr from "@/components/ImportTerr.vue";
import PuntosDeEncuentro from "@/components/PuntosDeEncuentro.vue";
// import { ref } from 'vue'
const territorios = useTerritoriosStore();
const territorio = useTerritorioStore();
const route = useRouterStore();
const { getItemUrl } = useMapData();

const filters1 = ref({ global: { value: "" } });
const editingItem = ref(null);
const clearFilter1 = () => { filters1.value = { global: { value: "" } }; };
const iframe = ref("null");
const props = defineProps({
  print: { type: Boolean, default: false },
});

const visibleLeft = ref(false);

let activeMode = props.print ? "map" : "list";
console.log("activeMode", activeMode);
const mode = ref(activeMode);
const modes = ref([
  // {icon: 'pi pi-align-left', value: 'Left'},
  // {icon: 'pi pi-align-right', value: 'Right'},
  { icon: "pi pi-list", value: "list" },
  // {icon: 'pi pi-table', value: 'map'},
  // {icon: 'pi pi-print', value: 'print'},
]);

// const edit = (item) => {
//   territorio.$patch(item);
//   route.$patch({ page: "formTerritorio" });
// };

const deleteItem = (item) => {
  territorios.$patch({
    puntoEncuentro: territorios.puntoEncuentro.filter((i) => i.id !== item.id),
  });
};

const setDefault = (item) => {
  territorios.$patch({
    puntoEncuentro: territorios.puntoEncuentro.map((p) => ({
      ...p,
      isDefault: p.id === item.id,
    })),
  });
};

const loadIframe = () => {
  // console.log("load iframe")
  var frame = iframe.value;
  frame.contentWindow.postMessage({
    call: "sendList",
    value: JSON.parse(JSON.stringify(territorios.list)),
  });
};

const print = () => {
  window.print();
};
window.addEventListener(
  "message",
  function (event) {
    var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
    // console.log("origen", origin, event)
    if (
      origin !== "http://localhost:8080" &&
      origin !== "https://territorios.web.app"
    )
      return;
    // console.log("origen ok")
    if (typeof event.data == "object" && event.data.call == "sendList") {
      // console.log("message", event.data)
      territorios.$patch({ list: event.data.value });
    }
  },
  false
);
</script>

<style scoped>
h1,
h2 {
  font-weight: lighter;
}

div.tarjeta {
  border: 1px solid rgb(219, 218, 216);
  padding: 5px;
  background: rgb(253, 253, 253);
  cursor: pointer;
  height: 100%;
}

.territorios {
  align-items: stretch;
}

.titles {
  text-align: left;
  padding: 5px 0px 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.titles h2,
.titles p {
  margin: 0;
  padding: 0;
  color: darkslategrey;
}

.titles h2 {
  font-weight: normal;
}

.titles p {
  padding-left: 0px;
  font-size: 0.9em;
}

.detalle {
  margin: 0px 0 0;
  text-align: left;
}

h5 {
  margin: 0;
  padding: 0;
}

.detalle h5 {
  padding-top: 10px;
}

.notas {
  font-size: 0.9em;
}
</style>
